import { render } from "./CabinetCategoryCard.vue?vue&type=template&id=7d44bc18&lang=pug"
import script from "./CabinetCategoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CabinetCategoryCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__